import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui-kit/button';

interface LinkedRecordBarProps {
  /** The record the page was linked to (useLinkedRecord); nothing shows without one. */
  linkedId: string;
  onShowAll: () => void;
}

/** Above a list narrowed to the one record a link (e.g. a notification) opened: says so, and shows the whole list again. */
export const LinkedRecordBar = ({ linkedId, onShowAll }: Readonly<LinkedRecordBarProps>) => {
  const { t } = useTranslation();
  if (!linkedId) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border bg-primary-50 px-3 py-2">
      <span className="min-w-0 flex-1 text-sm font-medium">{t('LINKED_RECORD_SHOWN')}</span>
      <Button type="button" size="sm" variant="outline" onClick={onShowAll}>
        {t('SHOW_ALL')}
      </Button>
    </div>
  );
};
